var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('h1',[_vm._v("All destinations")]),_c('div',{staticClass:"destinations"},_vm._l((_vm.destinations),function(destination){return _c('div',{key:destination.name},[_c('router-link',{attrs:{"to":{
          name: 'DestinationDetails',
          params: { slug: destination.slug },
        }}},[_c('h2',[_vm._v(_vm._s(destination.name))])]),_c('figure',[_c('router-link',{attrs:{"to":{
            name: 'DestinationDetails',
            params: { slug: destination.slug },
          }}},[_c('img',{attrs:{"src":require(("@/assets/" + (destination.image))),"alt":""}})])],1)],1)}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }